var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as R from 'ramda';
import * as A from './actions';
import * as H from './reducer-helper';
import { mapFreeFormStateKeys } from './selectors';
var initialState = {
    items: {},
    marker: {
        processInstanceId: null,
        taskDefinitionKey: null,
    },
    markers: [],
    mounted: false,
};
export var formReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case A.FORM_LOAD:
        case A.FORM_ACT_LOAD:
        case A.FORM_FREE_LOAD:
        case A.FORM_MODAL_LOAD:
        case A.FORM_REFRESH:
        case A.FORM_FREE_REFRESH:
            return H.setLoading(true, state);
        case A.FORM_NEXT:
        case A.FORM_SAVE:
        case A.FORM_FREE_SAVE:
        case A.FORM_MODAL_CLOSE:
        case A.FORM_ADD_BLOCK:
        case A.FORM_FREE_ADD_BLOCK:
        case A.FORM_REMOVE_BLOCK:
        case A.FORM_FREE_REMOVE_BLOCK:
        case A.FORM_CLICK_REQUEST:
            return H.setSubmitting(true, state);
        case A.FORM_CHANGE_MARKER: {
            var _a = action.payload, processInstanceId = _a.processInstanceId, taskDefinitionKey = _a.taskDefinitionKey, modalFormCode = _a.modalFormCode, initiatorId = _a.initiatorId;
            return R.pipe(H.changeMarker(processInstanceId, taskDefinitionKey, modalFormCode, initiatorId, null), H.setLoading(false))(state);
        }
        case A.FORM_SILENT_UPDATE: {
            var _b = action.payload, processInstanceId = _b.processInstanceId, taskDefinitionKey = _b.taskDefinitionKey, modalFormCode = _b.modalFormCode, def = _b.def;
            return R.assocPath(H.props2FormPath(processInstanceId, taskDefinitionKey, modalFormCode), def, state);
        }
        case A.FORM_FREE_SILENT_UPDATE: {
            var _c = action.payload, def = _c.def, params = __rest(_c, ["def"]);
            var _d = mapFreeFormStateKeys(params), processInstanceId = _d.processInstanceId, taskDefinitionKey = _d.taskDefinitionKey;
            return R.assocPath(H.props2FormPath(processInstanceId, taskDefinitionKey, null), def, state);
        }
        case A.FORM_LOAD_SUCCESS:
        case A.FORM_NEXT_SUCCESS: {
            var _e = action.payload, def = _e.def, processInstanceId = _e.processInstanceId, taskDefinitionKey = _e.taskDefinitionKey;
            return H.loadSuccessResult(def, processInstanceId, taskDefinitionKey, state);
        }
        case A.FORM_SAVE_SUCCESS: {
            var _f = action.payload, def = _f.def, processInstanceId = _f.processInstanceId, taskDefinitionKey = _f.taskDefinitionKey;
            return H.saveSuccessResult(def, processInstanceId, taskDefinitionKey, state);
        }
        case A.FORM_REFRESH_SUCCESS: {
            var _g = action.payload, def = _g.def, processInstanceId = _g.processInstanceId, taskDefinitionKey = _g.taskDefinitionKey, modalFormCode = _g.modalFormCode;
            return H.refreshSuccessResult(def, processInstanceId, taskDefinitionKey, modalFormCode, state);
        }
        case A.FORM_ADD_BLOCK_SUCCESS: {
            var _h = action.payload, processInstanceId = _h.processInstanceId, taskDefinitionKey = _h.taskDefinitionKey, modalFormCode = _h.modalFormCode, inputBlockId = _h.inputBlockId, prevBlockId = _h.prevBlockId, newBlock = _h.newBlock;
            // @ts-ignore
            return H.addBlockSuccessResult(processInstanceId, taskDefinitionKey, modalFormCode, inputBlockId, prevBlockId, newBlock, state);
        }
        case A.FORM_ADD_BLOCKS_SUCCESS: {
            var _j = action.payload, processInstanceId_1 = _j.processInstanceId, taskDefinitionKey_1 = _j.taskDefinitionKey, modalFormCode_1 = _j.modalFormCode, items = _j.items;
            return R.reduce(
            // @ts-ignore
            function (acc, _a) {
                var inputBlockId = _a.inputBlockId, prevBlockId = _a.prevBlockId, newBlock = _a.newBlock;
                return H.addBlockSuccessResult(processInstanceId_1, taskDefinitionKey_1, modalFormCode_1, inputBlockId, prevBlockId, newBlock, acc);
            }, state, items);
        }
        case A.FORM_REMOVE_BLOCK_SUCCESS: {
            var _k = action.payload, processInstanceId = _k.processInstanceId, taskDefinitionKey = _k.taskDefinitionKey, blockId = _k.blockId, modalFormCode = _k.modalFormCode;
            // @ts-ignore
            return H.removeBlockSuccessResult(processInstanceId, taskDefinitionKey, modalFormCode, blockId, state);
        }
        case A.FORM_REMOVE_BLOCKS_SUCCESS: {
            var _l = action.payload, processInstanceId_2 = _l.processInstanceId, taskDefinitionKey_2 = _l.taskDefinitionKey, blockIds = _l.blockIds, modalFormCode_2 = _l.modalFormCode;
            return R.reduce(
            // @ts-ignore
            function (acc, blockId) { return H.removeBlockSuccessResult(processInstanceId_2, taskDefinitionKey_2, modalFormCode_2, blockId, acc); }, state, blockIds);
        }
        case A.FORM_MODAL_LOAD_SUCCESS: {
            var _m = action.payload, def = _m.def, processInstanceId = _m.processInstanceId, taskDefinitionKey = _m.taskDefinitionKey, modalFormCode = _m.modalFormCode, initiatorId = _m.initiatorId;
            return H.childLoadSuccessResult(def, processInstanceId, taskDefinitionKey, modalFormCode, initiatorId, state);
        }
        case A.FORM_MODAL_CLOSE_SUCCESS: {
            var _o = action.payload, def = _o.def, processInstanceId = _o.processInstanceId, taskDefinitionKey = _o.taskDefinitionKey, modalFormCode = _o.modalFormCode, result = _o.result;
            return H.childSaveSuccessResult(def, processInstanceId, taskDefinitionKey, modalFormCode, result, state);
        }
        case A.FORM_CLICK_REQUEST_SUCCESS: {
            var _p = action.payload, processInstanceId = _p.processInstanceId, taskDefinitionKey = _p.taskDefinitionKey, modalFormCode = _p.modalFormCode, initiatorId = _p.initiatorId, result = _p.result;
            return H.clickRequestSuccessResult(processInstanceId, taskDefinitionKey, modalFormCode, initiatorId, result, state);
        }
        case A.FORM_LOAD_ERROR:
        case A.FORM_MODAL_LOAD_ERROR:
        case A.FORM_REFRESH_ERROR:
            return R.pipe(H.setError(action.payload.error), H.setLoading(false))(state);
        case A.FORM_SAVE_ERROR:
        case A.FORM_MODAL_CLOSE_ERROR:
        case A.FORM_NEXT_ERROR:
        case A.FORM_ADD_BLOCK_ERROR:
        case A.FORM_REMOVE_BLOCK_ERROR:
        case A.FORM_CLICK_REQUEST_ERROR:
            return R.pipe(H.setError(action.payload.error), H.setSubmitting(false))(state);
        case A.FORM_INTERNAL_LOADING:
            return H.setLoading(action.payload.loading, state);
        case A.FORM_INTERNAL_ERROR:
            return H.setError(action.payload.error, state);
        case A.FORM_MOUNT:
            return R.assoc('mounted', action.payload.mount, state);
    }
    return state.error ? H.setError('', state) : state;
};
//# sourceMappingURL=reducer.js.map